// components/Toast/ToastContainer.tsx
import { AnimatePresence } from 'framer-motion';
import React, { useEffect, useId, useState } from 'react';
import { ToastType } from '../enums/ToastType';
import { Toast } from './Toast';

interface ToastState {
	text: string;
	type: ToastType;
	visible: boolean;
}

let triggerToast: ((text: string, type: ToastType) => void) | null = null;

export const ToastContainer = () => {
	const [toast, setToast] = useState<ToastState | null>(null);
	const id = useId();

	useEffect(() => {
		triggerToast = (text: string, type: ToastType) => {
			setToast({ text, type, visible: true });
			setTimeout(() => {
				setToast((previous) => previous && { ...previous, visible: false });
			}, 3000);
		};
	}, []);

	return (
		<AnimatePresence>
			{toast?.visible && <Toast key={toast.text + toast.type + id} type={toast.type} text={toast.text} />}
		</AnimatePresence>
	);
};

export const toast = {
	error: (text: string) => triggerToast?.(text, ToastType.ERROR),
	info: (text: string) => triggerToast?.(text, ToastType.INFO),
};
